module.exports = __webpack_public_path__ + "img/maxword.4a89b22a.png";